/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Showcase_Viewdetails1Inputs */

const zh_showcase_viewdetails1 = /** @type {(inputs: Showcase_Viewdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看详情`)
};

const en_showcase_viewdetails1 = /** @type {(inputs: Showcase_Viewdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Details`)
};

const es_showcase_viewdetails1 = /** @type {(inputs: Showcase_Viewdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver detalles`)
};

/**
* | output |
* | --- |
* | "View Details" |
*
* @param {Showcase_Viewdetails1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const showcase_viewdetails1 = /** @type {((inputs?: Showcase_Viewdetails1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Showcase_Viewdetails1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_showcase_viewdetails1(inputs)
	if (locale === "en") return en_showcase_viewdetails1(inputs)
	return es_showcase_viewdetails1(inputs)
});
export { showcase_viewdetails1 as "showcase_viewDetails" }